import * as yup from "yup";
import { validationSchemas } from "./data";
export const voidReceiptSchema = yup.object().shape({
  voidReceipt: validationSchemas.name,
});
